export default __webpack_public_path__ + "static/media/dao_feed_page_icon.6d6959d7.svg";